module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('LangSwitcher', {
		
		configure: function () {
			this.currentLang = null;
			this._isOpened = false;

			this.langAliases = {
				es: 'sp'
			};

			this.fullLangList = {
				en: {
					alias: 'en',
					title: 'English'
				},
				sp: {
					alias: 'sp',
					title: 'Español'
				},
				it: {
					alias: 'it',
					title: 'Italiano'
				},
				ru: {
					alias: 'ru',
					title: 'Русский'
				},
				de: {
					alias: 'de',
					title: 'Deutsch'
				}
			};

			this.registerOptions('', {
				autoRender: true,
				container: '.lang-switcher-wrapper',
				template: 'promo_lang_switcher',
				langsList: ['en', 'ru', 'de', 'sp'],
				langsList2: {'en':'English', 'sp':'Español'},
				handleDom: {
					toggleList: {
						target: '.current',
						event: 'click',
						callback: '_toggleList'
					},

					switchLang: {
						target: '.lang-switcher .item',
						event: 'click',
						callback: '_switch'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.langsList = {};
			fox.each(this.getOption('langsList'), function(lang) {
				this.langsList[lang] = this.fullLangList[lang];
			}, this);
			
			this.dictionary = fox.site.wom1('#dictionary');

			if (!this.dictionary) {
				return;
			}

			var lang = fox.cookie.get('mc_lang');
			var myLangs = fox.getEnv('languages');

			if (lang && !this.langsList[lang]) {
				lang = false;
			}

			if (!lang && myLangs && myLangs.length) {
				for (var i = 0, l = myLangs.length; i < l; i++) {
					if (this.langsList[myLangs[i]]) {
						lang = myLangs[i];
						break;
					} else if (this.langAliases[myLangs[i]]) {
						lang = this.langAliases[myLangs[i]];
						break;
					}
				}
			}

			this.switchLang(lang ? lang : 'en');
			this.callParent('init', arguments);
		},

		running: function () {
			this.switchOnStart();
			this.callParent('running', arguments);
		},

		activate: function (argument) {
			this.switchOnStart();
			this.callParent('activate', arguments);
		},

		deactivate: function (argument) {
			this.removeDocumentClickHandler();
			this.callParent('deactivate', arguments);
		},

		switchOnStart: function() {
			var lang = fox.cookie.get('mc_lang');
			this.switchLang(lang ? lang : 'en');
			this.renderBlock();
			this.addDocumentClickHandler();
		},

		addDocumentClickHandler: function (argument) {
			$(window).on('click', {widget: this}, this._close)
		},

		removeDocumentClickHandler: function (argument) {
			$(window).off('click', this._close)
		},

		_getLangFromList: function (alias) {
			var result = {};

			fox.each(this.langsList, function (data) {
				if (data.alias == alias) {
					result = data;
				}
			}, this)
			
			return result;
		},

		prepareList: function () {

			var list = [
				this.langsList[this.currentLang]
			];
			fox.each(this.langsList, function(lang) {
				if (lang.alias != this.currentLang) {
					list.push(lang);
				}
			}, this);

			this.setTemplateOptions('currentLang', this._getLangFromList(this.currentLang));
			this.setTemplateOptions('list', list);
		},

		_switch: function (el, alias, w, e) {
			e.stopPropagation ? e.stopPropagation() : e.cancleBubble = true;
			var alias = fox.dom.wrap(el).attr('data-lang-alias');

			this.switchLang(alias);
			this.renderBlock();
			this.close();
		},

		switchLang: function (alias) {
			this.switchedLand = this.currentLang;
			this.currentLang = alias;

			fox.Consent.checkCookie('mc_lang').then(function() {
				fox.cookie.set('mc_lang', alias);
			});
			
			this.dictionary.setLang(alias);

			if (this.switchedLand != this.currentLang) {
				this.dispatchEvent('langSwitched');
			}

			$('.promo-wrapper').removeClass(this.switchedLand)
								.addClass(this.currentLang);
		},

		renderBlock: function () {
			this.prepareList();
			this.render();
		},

		_toggleList: function (el, alias, w, e) {
			e.stopPropagation ? e.stopPropagation() : e.cancleBubble = true;

			if (this._isOpened) {
				this.close();

				return;
			};

			this.open();
		},

		open: function () {
			fox.dom.addClass('open', this.dom1('.current'));
			this._isOpened = true;
		},

		close: function () {
			this._isOpened = false;
			fox.dom.removeClass('open', this.dom1('.current'));
		},

		_close: function (e) {
			e.data.widget.close();
		}

	});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/langSwitcher.js
// module id = 309
// module chunks = 2